import React from 'react';
import PropTypes from 'prop-types';
import generateQuestionFormName from 'utils/generateQuestionFormName';
import ButtonContentForm from './ButtonContentForm';

const ButtonContent = ({
  isCloned,
  block: { clientUuid },
  styling,
  block,
  onAnswer,
  answer,
  e2e,
  readOnly,
}) => (
  <ButtonContentForm
    e2e={e2e}
    form={generateQuestionFormName(clientUuid, isCloned)}
    block={block}
    styling={styling}
    onSubmit={onAnswer}
    initialValues={answer}
    readOnly={readOnly}
  />
);

ButtonContent.propTypes = {
  block: PropTypes.shape({
    clientUuid: PropTypes.string.isRequired,
  }).isRequired,
  isCloned: PropTypes.bool,
  e2e: PropTypes.string,
  styling: PropTypes.object,
  onAnswer: PropTypes.func.isRequired,
  answer: PropTypes.shape({
    value: PropTypes.bool.isRequired,
  }),
  readOnly: PropTypes.bool,
};

export default ButtonContent;
